<template>
	<el-dialog
		title="AI托管设置"
		:visible.sync="visible"
		width="600px"
		custom-class="ai-hosting-dialog"
		:close-on-click-modal="false"
		:modal-append-to-body="false"
		:append-to-body="true"
		@close="handleClose">
		<div class="ai-hosting-content">
			<div class="form-item-row">
				<span class="form-label">AI托管</span>
				<el-switch
					v-model="formData.enabled"
					active-color="#4ca0ff">
				</el-switch>
			</div>
		</div>

		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="handleConfirm">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		name: 'ai-hosting-setting',
		props: {
			value: {
				type: Boolean,
				default: false
			},
			// 当前客服数据
			serviceData: {
				type: Object,
				default: () => ({})
			}
		},
		data() {
			return {
				formData: {
					enabled: false,
				}
			}
		},
		computed: {
			visible: {
				get() {
					return this.value
				},
				set(val) {
					this.$emit('input', val)
				}
			}
		},
		watch: {
			value: {
				handler(val) {
					if (val && this.serviceData) {
						this.initFormData()
					}
				},
				immediate: true
			},
			serviceData: {
				handler(newVal, oldVal) {
					if (newVal) {
						this.initFormData()
					}
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			initFormData() {
				// 根据传入的客服数据初始化表单
				const data = this.serviceData
				this.formData = {
					enabled: data.enabled,
				}
			},
			handleClose() {
				this.$emit('input', false)
				this.$emit('close')
			},
			handleConfirm() {
				// 提交AI托管设置
				const postData = {
					csId: this.serviceData.csId,
					enabled: this.formData.enabled
				}
				this.$emit('confirm', postData)
				this.$emit('input', false)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.ai-hosting-content {
		padding: 10px 0;

		.form-item-row {
			display: flex;
			align-items: center;
			margin-bottom: 20px;

			.form-label {
				min-width: 130px;
				font-size: 14px;
				color: #333;
				text-align: right;
				padding-right: 12px;
			}

			.el-radio-group {
				display: flex;
				flex-wrap: wrap;
				gap: 16px;

				.el-radio {
					margin-right: 0;
				}
			}

			.duration-wrapper {
				flex: 1;
				max-width: 200px;
			}

			&.disabled {
				opacity: 0.6;
			}
		}

		.tips-text {
			font-size: 12px;
			color: #999;
			margin-top: 8px;
			line-height: 1.5;
			padding-left: 130px;
		}
	}
</style>

<style lang="scss">
	.ai-hosting-dialog {
		.el-dialog__body {
			padding: 15px 20px 10px;
		}
	}
</style>
